import { NotInterested } from '@mui/icons-material';
import { Grid2, Typography, Container } from '@mui/material';

function NoProjects() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        [theme => theme.breakpoints.up('md')]: {
          height: '65vh',
        },
      }}
      data-testid="noProjects"
      data-cy="noProjects"
    >
      <Grid2
        container
        direction="column"
        alignItems="center"
        sx={theme => ({
          height: '100%',
          paddingTop: theme.spacing(22),
          [theme => theme.breakpoints.down('lg')]: {
            paddingTop: theme.spacing(16),
          },
        })}
      >
        <Grid2 item>
          <NotInterested fontSize="large" />
        </Grid2>
        <Grid2 item>
          <Typography
            variant="h3"
            gutterBottom
            sx={theme => ({
              color: 'inherit',
              letterSpacing: '.7rem',
              fontWeight: theme.typography.fontWeightLight,
              [theme => theme.breakpoints.only('xs')]: {
                fontSize: 24,
              },
            })}
          >
            No projects
          </Typography>
        </Grid2>
        <Grid2 item>
          <Typography component="p" color="inherit">
            Couldn&apos;t find any projects matching your search criteria,
            please try again
          </Typography>
        </Grid2>
      </Grid2>
    </Container>
  );
}

export default NoProjects;
